// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { ICON_VARIABLES } from 'shared/styles/Icons';

// styles
const Nav = styled.i<{ type: 'prev' | 'next' }>`
  background: transparent;
  font-size: 24px;

  &:after {
    content: '${ICON_VARIABLES['icon-arrow']}';
    color: #000;
    font-weight: 500;
  }

  &:before {
    content: '${ICON_VARIABLES['icon-arrow']}';
    color: #fff;
    position: absolute;
    left: 2px;
  }

  ${({ type }) =>
    type === 'next' &&
    `
    transform: rotate(180deg);
    margin-left: -19px;
    box-shadow: 5px;
    `}
`;

// def
interface INavButtonProps {
  type: 'prev' | 'next';
}

function NavButton({ type }: INavButtonProps) {
  return <Nav type={type} className="icon-arrow" />;
}

export default memo(NavButton);
